// The Go API (api.moneyhq.in in production). Every call sends the session cookie; a 401 means
// the session is gone, so the app goes to sign-in and comes back here afterwards.
export const API_URL = (import.meta.env.VITE_API_URL ?? 'http://127.0.0.1:8080').replace(/\/$/, '');

export const apiUrl = (path: string) => API_URL + path;

export function toSignIn() {
  // Already on sign-in: a 401 there is expected (nobody is signed in yet). Going to /login again
  // would reload the page over and over.
  if (location.pathname.startsWith('/login')) return;
  const here = location.pathname + location.search;
  location.assign(`/login?next=${encodeURIComponent(here)}`);
}

export async function api(path: string, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers);
  if (init.body && !headers.has('content-type')) headers.set('content-type', 'application/json');
  const r = await fetch(apiUrl(path), { ...init, headers, credentials: 'include', cache: 'no-store' });
  if (r.status === 401 && !path.startsWith('/v1/auth/')) toSignIn();
  return r;
}

/** Live updates (server-sent events) with the session cookie. */
export const stream = (path: string) => new EventSource(apiUrl(path), { withCredentials: true });
